import { render } from "./ResetPassword.vue?vue&type=template&id=7de304fd&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=ts"
export * from "./ResetPassword.vue?vue&type=script&lang=ts"

import "./ResetPassword.vue?vue&type=style&index=0&id=7de304fd&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7de304fd"

export default script